import { cn } from '../ui/cn';

/**
 * Skeleton placeholder for data panels (PRO-0050 / PRO-0300 DS-4). Renders non-blank
 * loading regions with an accessible status message, so the admin console never
 * shows empty space while a fetch is in flight.
 */
export function Skeleton({ rows = 3, label }: { rows?: number; label: string }) {
  return (
    <div role="status" aria-live="polite" aria-busy="true">
      <span className="sr-only">{label}</span>
      {Array.from({ length: rows }).map((_, index) => (
        <div
          key={index}
          aria-hidden="true"
          className={cn('my-1 h-5 animate-pulse rounded bg-muted')}
        />
      ))}
    </div>
  );
}
